import { render } from "./Alphacredit.vue?vue&type=template&id=3d36549e"
import script from "./Alphacredit.vue?vue&type=script&lang=js"
export * from "./Alphacredit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\2\\s\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__